import React, {
  forwardRef,
  useImperativeHandle,
  useLayoutEffect,
  useRef,
  useState
} from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { TOAST_TYPE_DEFAULT } from '../../libraries/Toast'
import { getMergedClassNames } from '../../utils/HTMLutils'
import Toast, { ToastProps } from '../toast/Toast'
import './ToastManager.scss'

const rootClassName = 'comp-toast-manager'

interface ToastManagerProps {
  max?: string | number
  marginTop?: string | number
  verticalPosition?: 'top' | 'bottom'
  horizontalPosition?: 'left' | 'right' | 'center'
  reverse?: boolean
  animateSize?: boolean
  pauseOnFocusLoss?: boolean
}

let count: any = 0
export const ToastManager = forwardRef((props: ToastManagerProps, ref: any) => {
  const [arrayOfToast, setArrayOfToast] = useState<any[]>([])
  const toasts = useRef(arrayOfToast)

  toasts.current = arrayOfToast

  const closeById = (id: string) => {
    const arr = toasts.current.filter((a: any) => a.id !== id)
    setArrayOfToast(arr)
  }

  useImperativeHandle(ref, () => ({
    showToast(
      toast: ToastProps | string,
      type = TOAST_TYPE_DEFAULT,
      timeout: number,
      showStatusBar = false,
      prevent = false
    ) {
      const id: string = `toaster-${count}`
      const arr: any[] = arrayOfToast.slice()
      let obj: any = {}
      if (typeof toast === 'string') {
        if (prevent && toasts.current.some((t: any) => t.label === toast)) {
          return
        }
        obj = { id, label: toast, type, timeout, showStatusBar }
      } else {
        if (
          toast.prevent &&
          toasts.current.some((t: any) => t.label === toast.label)
        ) {
          return
        }
        obj = { id, ...toast }
      }
      if (!props.max || toasts.current.length < props.max) {
        arr.push(obj)

        setArrayOfToast(arr)
        count++
      }
    },
    clearToast() {
      setArrayOfToast([])
    }
  }))

  const getClassNames = () => {
    return getMergedClassNames([
      `${rootClassName}-toasts`,
      `${rootClassName}-${props.verticalPosition}`,
      `${rootClassName}-${props.horizontalPosition}`,
      props.reverse ? `${rootClassName}-reverse` : '',
      props.animateSize ? `${rootClassName}-animate-size` : ''
    ])
  }

  useLayoutEffect(() => {
    const wrapper = document.querySelector(
      `.${rootClassName}-toasts`
    ) as HTMLElement
    if (wrapper && wrapper.childElementCount > 0) {
      let somaDasAlturas = 0
      if (props.verticalPosition === 'top' && !props.reverse) {
        somaDasAlturas = 12
        for (let i = 0; i < wrapper.children.length; i++) {
          const el = wrapper.children[i] as HTMLElement
          if (!el.classList.contains(`${rootClassName}-toast-exit`)) {
            el.style.transform = `translateY(${somaDasAlturas}px)`
            somaDasAlturas += el.getBoundingClientRect().height + 12
          }
        }
      } else if (props.verticalPosition === 'top') {
        for (let i = wrapper.children.length - 1; i >= 0; i--) {
          const el = wrapper.children[i] as HTMLElement
          if (!el.classList.contains(`${rootClassName}-toast-exit`)) {
            somaDasAlturas += el.getBoundingClientRect().height + 12
            el.style.transform = `translateY(${somaDasAlturas}px)`
          }
        }
      } else if (props.verticalPosition === 'bottom' && !props.reverse) {
        for (let i = 0; i < wrapper.children.length; i++) {
          const el = wrapper.children[i] as HTMLElement
          if (!el.classList.contains(`${rootClassName}-toast-exit`)) {
            somaDasAlturas += el.getBoundingClientRect().height + 12
            el.style.transform = `translateY(-${somaDasAlturas}px)`
          }
        }
      } else {
        somaDasAlturas = 12
        for (let i = wrapper.children.length - 1; i >= 0; i--) {
          const el = wrapper.children[i] as HTMLElement
          if (!el.classList.contains(`${rootClassName}-toast-exit`)) {
            el.style.transform = `translateY(-${somaDasAlturas}px)`
            somaDasAlturas += el.getBoundingClientRect().height + 12
          }
        }
      }
    }
  }, [arrayOfToast, props.reverse, props.verticalPosition])

  return (
    <React.Fragment>
      <TransitionGroup className={getClassNames()}>
        {arrayOfToast.map((toast: any) => {
          return (
            <CSSTransition
              timeout={300}
              classNames={`${rootClassName}-toast`}
              key={toast.id}
              unmountOnExit
            >
              <div className={`${rootClassName}-toastzin`}>
                <Toast
                  theme={toast.type}
                  label={toast.label}
                  onClose={() => closeById(toast.id)}
                  timeout={toast.timeout}
                  showStatusBar={toast.showStatusBar}
                  showActionButton={toast.showActionButton}
                  onActionButtonClick={toast.onActionButtonClick}
                  actionButtonText={toast.actionButtonText}
                  pauseOnFocusLoss={props.pauseOnFocusLoss}
                />
              </div>
            </CSSTransition>
          )
        })}
      </TransitionGroup>
    </React.Fragment>
  )
})

ToastManager.defaultProps = {
  verticalPosition: 'top',
  horizontalPosition: 'right'
}
